<template>
  <h3 class="text-lg font-semibold text-green-400 md:text-3xl"
      :class="alignment">
    {{title}}
  </h3>
</template>

<script setup>
defineProps({
  title: {
    type: String,
  },
  alignment: {
    type: String,
    default: 'text-center'
  }
})
</script>
